import { useEffect, useState } from "react";
import axios from "axios";

import { useBroadcastEditContext } from "../BroadcastEditContainer";

const EMPTY = { text: null, errors: [], unavailable: false };

const useRenderedSms = (draft) => {
  const { csrfToken, team, broadcast, sampleTwilioData } = useBroadcastEditContext();
  const [rendered, setRendered] = useState(EMPTY);
  const templateId = broadcast.twilio_template?.id;

  useEffect(() => {
    if (!draft?.trim() || !templateId) {
      setRendered(EMPTY);
      return undefined;
    }

    setRendered((previous) => ({ ...EMPTY, errors: previous.errors }));

    let current = true;
    const debounce = setTimeout(() => {
      axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;
      axios.post(`/teams/${team.id}/twilio_templates/${templateId}/parse_liquid`, {
        twilio_template: { template: draft, sample_data: sampleTwilioData },
      })
        .then(({ data }) => { if (current) setRendered({ ...EMPTY, text: data.parsedText, errors: data.liquidErrors || [] }); })
        .catch(() => { if (current) setRendered({ ...EMPTY, unavailable: true }); });
    }, 400);

    return () => { current = false; clearTimeout(debounce); };
  }, [draft, templateId]);

  return rendered;
};

export default useRenderedSms;
